import constants from "./CONSTANTS";

const localStorageLang = localStorage.getItem("lang");

export const initState = {
  lang: localStorageLang ?? "ge",
  privacyPolicy: null,
};

const reducer = (state = initState, action) => {
  switch (action.type) {
    case constants.SET_PRIVACY_POLICIES:
      return {
        ...state,
        privacyPolicy: action.payload,
      };
  
    default:
      return state;
  }
};

export default reducer;
